export function successRecomends(array){
    return{
        type:'ADD_ARRAY',
        payload:array
    }
}